import { createSlice, PayloadAction } from "@reduxjs/toolkit"

const initialState = {
  profile: null,
  wishListsWithFirstFourItems: null,
  wishLists: null,
  wishItems: null
} as UserInfo

export const viewedUser = createSlice({
  name: "viewedUser",
  initialState: initialState,
  reducers: {
    updateViewedUserProfile: (state, action: PayloadAction<Profile | null>) => {
      state.profile = action.payload || null
    },
    updateViewedUserWishListsWithFirstFourItems: (state, action: PayloadAction<GetWishListsResponseDto>) => {
      state.wishListsWithFirstFourItems = structuredClone(action.payload.wishlists)
    },
    updateViewedUserWishLists: (state, action: PayloadAction<GetWishListsResponseDto>) => {
      state.wishLists = structuredClone(action.payload.wishlists)
    },
    updateViewedUserWishItems: (state, action: PayloadAction<GetWishItemsResponseDto>) => {
      state.wishItems = action.payload.items
    },
    updateViewedUserFollowRequested: (state) => {
      if (!state.profile) return
      state.profile.requestedToFollow = false
    },
    resetViewedUserProfileSlice: () => structuredClone(initialState)
  }
})

export const {
  updateViewedUserProfile,
  updateViewedUserWishListsWithFirstFourItems,
  updateViewedUserWishLists,
  updateViewedUserWishItems,
  updateViewedUserFollowRequested,
  resetViewedUserProfileSlice
} = viewedUser.actions

export default viewedUser.reducer
